var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77808 22H20C21.1046 22 22 21.1046 22 20V16C22 14.8954 21.1046 14 20 14H17.7781L9.77808 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4977 18.1591L19.4852 10.1716C20.2663 9.39055 20.2663 8.12422 19.4852 7.34317L16.6568 4.51474C15.8758 3.73369 14.6094 3.73369 13.8284 4.51474L11.5 6.84313V18C11.5 18.0532 11.4992 18.1063 11.4977 18.1591Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18V4C2 2.89543 2.89543 2 4 2H8C9.10457 2 10 2.89543 10 4V18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18ZM6 19.5C6.82843 19.5 7.5 18.8284 7.5 18C7.5 17.1716 6.82843 16.5 6 16.5C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8284 5.17157 19.5 6 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/color-palette.59ecd62be4457b2c10ad9e3eb7534e09.svg";
export { ForwardRef as ReactComponent };